module.exports = __webpack_public_path__ + "img/rememberYes.df741cf6.svg";